module.exports = __webpack_public_path__ + "static/Hotel-663af5cbe18bb3ed5c980e86bac8f83a.jpg";